import React from 'react';

import { Prompt } from 'sellDirect/helpers/closingDash/disclosures';
import { Flex, Icon, Text } from '@opendoor/bricks/core';
import { Tooltip } from '@opendoor/bricks/complex';

export interface BaseQuestionProps {
  question: Prompt;
}

/**
 * Creates question component based on question data
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const BaseQuestion: React.FC<BaseQuestionProps> = ({ question, children }) => {
  return (
    <Flex
      key={question.id}
      flexDirection="column"
      id={`question-${question.id}`}
      bgColor="transparent"
      gap="16"
    >
      <Text fontWeight="semibold" size="s1">
        {question.description ? (
          <Flex justifyContent="space-between" alignItems="center">
            {question.displayText}

            <Tooltip
              analyticsName={`${question.id}-tooltip`}
              label={`${question.id}-tooltip`}
              popupDirection="top"
              tooltipIcon={<Icon name="info" size={24} />}
            >
              {question.description}
            </Tooltip>
          </Flex>
        ) : (
          question.displayText
        )}
      </Text>
      {children}
    </Flex>
  );
};
